import { CircularProgress, LinearProgress, Tab, Tabs as MUITabs, Box, Typography } from "@mui/material";
import { useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router";
import { useReactToPrint } from "react-to-print";
import { toast } from "react-toastify";
import { io } from "socket.io-client";
import api, { downloadFile } from "../../BrandOnBoarding/api";
import Header from "../../Component/Header/Header";
import Modal from "../../Component/Modal/Modal";
import PDFFooter from "../../Component/PDFFooter/PDFFooter";
import PDFHeader from "../../Component/PDFHeader/PDFHeader";
import MUIButton from "../../Component/UI/MUIButton/MUIButton";
import Tabs from "../../Component/UI/Tabs/Tabs";
import { AuthContext } from "../../context/auth-context";
import { useDailyLimits } from "../../hooks/useDailyLimits";
import { LLM_OPTIONS, OVERVIEW_LLM_LABELS } from "../../utils/constant";
import useHistory from "../BrandAudit/History/useHistory";
import classes from "./BrandAudit.module.css";
import BrandScore, { tab } from "./BrandScore/BrandScore";
import { DiscoveryContext } from "./discovery-context";
import Form from "./Form";
import History from "./History/History";
import SelectedComponent from "./SelectedComponent/SelectedComponent";
import userMetricSettingCreation from "../Set/userMetricSettingCreation";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { getReportDownloadUrl, updateValidatedSources, validateBrandInputValue, validateProductInputValue } from "../../utils/helpers";
import SummaryReportModal from "./SummaryReportModal";
import { getMetricsRecord } from "../../utils/constant"
import { ENTITY_LABELS } from "../../utils/labelMapping";
import { fetchPersonas } from "../../redux/actions/personasActions";
// signalStrength's "pending validation" sources can arrive as a plain URL string
// (old/legacy), a per-URL {url, count, http_status} object, or an already-merged
// {url: count, ...} map (v4's live socket push) — normalize each to a single-key
// {url: count} entry (or pass an already-merged map through as-is) so the reducer's
// merge-by-spread logic works regardless of which shape the backend sent.
function toOldSourcesEntry(entry) {
  if (typeof entry === "string") return { [entry]: 1 };
  if (entry && typeof entry === "object" && "url" in entry) {
    return { [entry.url]: entry.count ?? 1 };
  }
  return entry;
}

export const filterKey = {
  llm: "llm_select",
  category: "category_select",
  market: "market_select",
  persona: "persona_select",
  competitor: "competitor_select",
};

export default function BrandAudit() {
  const [inputValues, setInputValues] = useState({
    brand: "",
    category: "",
    market: "",
    llm: "",
    type: "brand",
  });
  const [tabSelected, setTabSelected] = useState("overview");
  const [externalReportLoading, setExternalReportLoading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [warningText, setWarningText] = useState("");
  const [cancelTransaction, setCancelTransaction] = useState(false);
  const [showLunchDialog, setShowLunchDialog] = useState(false);
  const [discoveryTypeChange, setDiscoveryTypeChange] = useState("brand");
  const [activeTab, setActiveTab] = useState(0);
  const [dashbaordActiveTab, setDashbaordActiveTab] = useState(0);
  const [launchType, setLaunchType] = useState("test");
  const [processRetry, setProcessRetry] = useState(false);
  const [domain, setDomain] = useState("");
  const [isAuditRunning, setIsAuditRunning] = useState(false);
  const { user, setSelectedCustomerById } = useContext(AuthContext);
  const [showSummaryReportModal, setShowSummaryReportModal] = useState(null);

  const dispatch = useDispatch();
  const transactionIdRef = useRef(null);
  const pollingRef = useRef(null);
  const metricsRecord = getMetricsRecord();
  const {
    launchText,
    hoverText,
    updateLaunches,
    launchesRemaining,
    isSpecial,
    frequency: launchLimitFrequency,
    updatePersonasOnly,
    // personas: userPersonas,
  } = useDailyLimits("BrandAudit");

  const discoveryCtx = useContext(DiscoveryContext);
  const discoveryCtxRef = useRef(discoveryCtx);
  const abortControllerRef = useRef(null);
  const location = useLocation();
  const entity = discoveryCtx.entity;
  const discoveryType = discoveryCtx.type || "brand";
  const { getHistory } = useHistory(discoveryType);
  const pdfRef = useRef();
  const rankScoreAbortCtrRef = useRef(null);
  const socketRef = useRef(null); // persists across renders
  const webSocketBaseURL = process.env.REACT_APP_ORCHESTRATOR_BASE_URL;
  const showLaunchMessage = localStorage.getItem("showLaunchMessage");
  const showUserMetricSettingModel = useSelector(
    (store) => store.userSet.showModel
  );
  const testLLMModel = process.env.REACT_APP_LOWCOST_MODEL;
  const [auditJobId, setAuditJobId] = useState(null);
  const [auditJobStatus, setAuditJobStatus] = useState(null); // "pending" | "running" | "completed" | "failed"
  const [auditPercent, setAuditPercent] = useState(0);
  const [auditMessages, setAuditMessages] = useState([]);
  const auditPollTimerRef = useRef(null);
  const auditInitialTimerRef = useRef(null);
  const auditConsecutiveFailuresRef = useRef(0);
  const downloadedForJobRef = useRef(null);
  const enableReport = discoveryCtx?.state?.transactionStatus === "COMPLETED";
  const [reportLoading, setReportLoading] = useState(false);
  const enableSummaryReport = user?.is_brand_audit_summary_report_enabled
  const enableHTMLReport = user?.is_brand_audit_html_report_enabled;
  const isComprehensiveReportEnabled = user?.is_brand_audit_comprehensive_report_enabled || false;
  const enableTestConvoContentMap = !!user?.enableTestBrandAuditConversationContentMapping;
  const customerId = user?.customer_id;
  useEffect(() => {
    if (!socketRef.current) {
      const isProd = process.env.REACT_APP_ENV === "production";

      const socketOptions = {
        reconnectionAttempts: 5,
      };

      const socketUrl = process.env.REACT_APP_SOCKET_BASE_URL;

      if (isProd) {
        socketOptions.path = "/ows/";
      } else {
        socketOptions.transports = ["websocket"];
      }

      // Initialize socket
      socketRef.current = io(socketUrl, socketOptions);

      socketRef.current.on("connect", () => {
        console.log("Socket connected:", socketRef.current.id);
      });

      socketRef.current.on("disconnect", () => {
        console.warn("Socket disconnected");
      });

      socketRef.current.on("live-data", handleSocketData);
    }

    const handleOnline = () => {
      if (socketRef.current) {
        if (!socketRef.current.connected && !socketRef.current.active) {
          console.log("Network back online, reconnecting socket...");
          socketRef.current.connect();
        } else {
          console.log("Socket already connected or reconnecting, skipping...");
        }
      }
    };

    window.addEventListener("online", handleOnline);

    return () => {
      // Optional: Cleanup if needed
      // socketRef.current?.disconnect();
      window.removeEventListener("online", handleOnline);
      transactionIdRef.current = null;
    };
  }, []);
  useEffect(() => {
    if (discoveryCtx.state.transactionId) {
      transactionIdRef.current = discoveryCtx.state.transactionId;
    } else {
      transactionIdRef.current = null;
    }
  }, [discoveryCtx.state.transactionId]);

  useEffect(() => {
    discoveryCtxRef.current = discoveryCtx;
  }, [discoveryCtx]);

  useEffect(() => {
    if (customerId) {
      dispatch(fetchPersonas(customerId));
    }
  }, []);

  const handleSocketData = (data) => {
    if (!data) {
      console.error("Received null or undefined socket data.");
      return;
    }
    let transactionId;
    let type,
      request,
      response,
      category,
      llm,
      market,
      persona,
      transaction,
      completedTaskCount,
      coreAttributeData,
      isValidated,
      commonReq;

    if (Array.isArray(data?.coreAttributeData)) {
      if (!data?.coreAttributeData[0]) {
        console.error("CoreAtribute data is empty or invalid:", data);
        return;
      }
      transactionId = data?.coreAttributeData[0]?.transaction?.transaction_id;
      type = data?.coreAttributeData[0]?.type;
      coreAttributeData = data?.coreAttributeData;
      completedTaskCount = data?.completedTaskCount;
      isValidated = data?.isValidated;
      commonReq = {
        category: data?.coreAttributeData[0]?.category ?? "",
        llm: data?.coreAttributeData[0]?.llm ?? "",
        market: data?.coreAttributeData[0]?.market ?? "",
        persona: data?.coreAttributeData[0]?.persona ?? "",
      };
    } else {
      ({
        type,
        request,
        response,
        category,
        llm,
        market,
        persona,
        transaction,
        completedTaskCount,
        isValidated,
      } = data);
      transactionId = transaction?.transaction_id
        ? transaction?.transaction_id
        : data?.transactionId;
      commonReq = {
        category: category ?? "",
        llm: llm ?? "",
        market: market ?? "",
        persona: persona ?? ""
      };
    }

    const currentContextTxnId = transactionIdRef.current;
    if (transactionId !== currentContextTxnId) return;
    if (
      data?.status === "Transaction Successfull" ||
      data?.status === "Transaction failed"
    ) {
      loadBrandAudit(
        transactionId,
        discoveryCtxRef?.current?.type,
        user?.user_role?.user_id,
        true
      );
      discoveryCtx.updateTransactionStatus(
        data?.status === "Transaction Successfull" ? "COMPLETED" : "RETRY"
      );
      if (transactionId === discoveryCtxRef.current.state.finalTransactionId) {
        discoveryCtx.updateFinalTransactionStatus("COMPLETED");
      }
    }
    if (data?.sourceValidationStatus) {
      loadBrandAudit(
        transactionId,
        discoveryCtxRef?.current?.type,
        user?.user_role?.user_id,
        true
      );
      discoveryCtx.updateSourceValidationStatus(data?.sourceValidationStatus);
    }
    const showOldSourcesRecord = data?.SourceValidatorStatus === "PENDING";
    discoveryCtx.updateStatus({ completedTaskCount });
    const onlyIfValidated = (data, empty = Array.isArray(data) ? [] : {}) => {
      if (showOldSourcesRecord) {
        if (Array.isArray(data)) return data;
        if (data == null) return [];
        return [data];
      }

      return isValidated ? data : empty;
    };
    console.log("brandAuditSocketData", data);

    switch (type) {
      case "rank":
        if (!response) return console.warn("Missing response for 'rank'");
        response = { ...response, request_id: data.id, isValidated };
        const sourcesRank = onlyIfValidated(response?.sources?.rank || [], []);
        discoveryCtx.updateRankScores({
          req: commonReq,
          res: response,
        });
        discoveryCtx.updateSources({
          res: sourcesRank,
          req: commonReq,
          showOldSourcesRecord,
          type: metricsRecord[type]
        });
        break;

      case "sentiment":
        if (!response || !transaction || !request?.category) {
          console.warn("Invalid sentiment data:", response, transaction);
          return;
        }

        const entity = { ...response?.data }?.[0];
        const entityRecord = response?.data?.[0];
        const sentimentSources = [response?.sources?.sentiment || {}];
        const updatedExtras = !showOldSourcesRecord
          ? updateValidatedSources(response.extras)
          : response.extras;
        const brandRes = response?.error
          ? { error: "something went wrong" }
          : {
            name: entity?.name || "Unknown",
            favorability: entity?.score ?? 0,
            extras: updatedExtras,
            sentimentSources,
            isValidated,
            rbiType: response?.rbiType,
          };
        const competitors =
          discoveryCtxRef.current?.competitors?.[request.category] || [];
        let index = competitors.findIndex(
          (item) => item.name?.toLowerCase() == entity?.name?.toLowerCase()
        );
        if (transaction?.brand === entity?.name) index = -1;

        discoveryCtx.updateBrandScores({
          req: commonReq,
          res: { data: brandRes, index: index + 1 },
          sentimentSources,
          isValidated,
        });
        discoveryCtx.updateSources({
          res: sentimentSources,
          req: commonReq,
          showOldSourcesRecord,
          type: metricsRecord[type]
        });
        break;

      case "signalStrength":
        if (!response) return console.warn("Missing response for signalStrength");
        const negativeAttributes = response?.aggregatedNegatives || [];
        const positiveAttributes = response?.aggregatedPositives || [];

        let sourcesPositiveArray = onlyIfValidated(
          response?.aggregatedPositiveSources || [],
          []
        );
        let sourcesNegativeArray = onlyIfValidated(
          response?.aggregatedNegativeSources || [],
          []
        );

        if (showOldSourcesRecord) {
          // v4's live signalStrength push sends each entry as a single already-merged
          // {url: count, ...} map (wrapped one-per-array-item), not one object per URL —
          // pass those through unchanged instead of reading a nonexistent .url/.count off
          // the whole map. Still handles the {url, count, http_status}-per-entry shape and
          // genuinely old plain-string entries, in case either is ever sent here too.
          sourcesPositiveArray = sourcesPositiveArray.map(toOldSourcesEntry);
          sourcesNegativeArray = sourcesNegativeArray.map(toOldSourcesEntry);
        }

        discoveryCtx.updatePositiveNegativeAttributes({
          res: {
            name: data?.brand,
            positives: positiveAttributes,
            negatives: negativeAttributes,
          },
          req: commonReq
        });

        discoveryCtx.updateSources({ res: sourcesPositiveArray, req: commonReq, showOldSourcesRecord, type: "Positive Attributes" });
        discoveryCtx.updateSources({ res: sourcesNegativeArray, req: commonReq, showOldSourcesRecord, type: "Negative Attributes" });
        break;

      case "categoryDimension":
        if (!response)
          return console.warn("Missing response for 'categoryDimension'");
        const normalize = (src) =>
          Array.isArray(src)
            ? onlyIfValidated(src, [])
            : onlyIfValidated(src ? [src] : [], []);

        const sourcesCategory = normalize(response?.sources?.category);
        const sourcesDim = normalize(response?.sources?.dimension);

        const sourcesCategoryDim = [...sourcesCategory, ...sourcesDim];
        discoveryCtx.updateCategoryDimensions({
          ...commonReq,
          data: response?.data || [],
          summary: response?.summary || "",
          sources: sourcesCategory,
          baseResponses: { ...(response?.baseResponses || {}), multi_prompting: response?.multi_prompting || false, num_runs: response?.num_runs },
          isValidated,
        });

        discoveryCtx.updateSources({
          res: sourcesCategoryDim,
          req: commonReq,
          showOldSourcesRecord,
          type: metricsRecord[type]
        });

        break;
      case "taxonomy":
        if (!response) return console.warn("Missing response for taxonomy");
        response = { ...response, isValidated };
        discoveryCtx.updatedTaxonomies({
          res: response,
          req: commonReq
        });
        break;

      case "core-attribute":
        if (!Array.isArray(coreAttributeData)) {
          console.warn("Expected array for core-attribute:", coreAttributeData);
          return;
        }
        // Grouping by category + llm _market+persona
        const expectedCount =
          (discoveryCtxRef.current?.competitors?.['default']?.length ?? 0) +
          (discoveryCtxRef.current?.competitors?.[coreAttributeData?.[0]?.category]?.length ?? 0);

        if (coreAttributeData?.length == expectedCount) {
          const groupedByCategoryAndLlm = coreAttributeData.reduce(
            (acc, item) => {
              const category = item?.category;
              const llm = item?.llm;
              const persona = item?.persona;
              const market = item?.market;
              if (!category || !llm || !persona || !market) return acc;

              const key = `${category}__${llm}__${market}_${persona}`; // unique key per group
              if (!acc[key]) acc[key] = [];
              acc[key].push(item);

              return acc;
            },
            {}
          );

          // Debug log
          // Process each group
          Object.entries(groupedByCategoryAndLlm).forEach(([key, items]) => {
            const [category] = key.split("__");
            const resData = items
              .filter((res) => res?.response)
              .map((res) => res.response);

            let coreAttributeSummary = "";
            let category_averages = resData[0]?.category_averages || {};
            let products = [];
            const sources = [];

            for (let res of resData) {
              if (!res?.error) {
                coreAttributeSummary += res.products?.[0]?.summary || "";
                coreAttributeSummary += "\n\n";
                // products.push(res.products?.[0]);
                const productSources = onlyIfValidated(
                  res?.sources?.product || [],
                  []
                );
                products.push({
                  ...res.products?.[0],
                  brandName: res.brandName,
                  sources: productSources,
                  baseResponses: res.baseResponses || null,
                  multi_prompting: res.multi_prompting || false,
                  num_runs: res.num_runs,
                });
                if (showOldSourcesRecord || isValidated) {
                  const normalize = (src) =>
                    Array.isArray(src) ? src : src ? [src] : [];

                  const categorySources = normalize(res?.sources?.category);
                  const productSources = normalize(res?.sources?.product);

                  sources.push(...categorySources, ...productSources);
                }
              }
            }

            const competitors =
              discoveryCtxRef?.current?.competitors?.[category] || [];
            const entities = competitors?.map((item) => item.name);
            entities.unshift(
              discoveryCtxRef.current?.competitors?.["default"]?.[0]?.name || ""
            );
            const sortedProducts = [];
            let baseResponsesArray = [];
            entities.forEach((company) => {
              const normalizedCompany = company
                .toLowerCase()
                .replace(/\s+/g, "");
              for (const product of products) {
                const normalizedProductName = (
                  product?.brandName ||
                  product?.name ||
                  ""
                )
                  ?.toLowerCase()
                  ?.replace(/\s+/g, "");
                if (normalizedProductName === normalizedCompany) {
                  // Extract baseResponses and add to separate array
                  if (product.baseResponses && typeof product.baseResponses === 'object') {
                    const baseResObj = product.baseResponses;
                    if (baseResObj.baseResponses && Array.isArray(baseResObj.baseResponses)) {
                      const firstItem = baseResObj.baseResponses[0];
                      const isPerAttributeMulti = firstItem?.attribute != null && Array.isArray(firstItem?.runs);
                      const isFlatRunMulti = firstItem?.run != null && firstItem?.baseRes != null && baseResObj.baseResponses.length > 1;
                      const isMultiPrompting = product.multi_prompting === true || isPerAttributeMulti || isFlatRunMulti;
                      baseResponsesArray.push({
                        brandName: product.brandName,
                        basePrompt: baseResObj.basePrompt || "",
                        multi_prompting: isMultiPrompting,
                        num_runs: product.num_runs || (isPerAttributeMulti ? firstItem?.runs?.length : undefined),
                        baseResponse: isPerAttributeMulti
                          ? baseResObj.baseResponses
                          : isFlatRunMulti
                            ? baseResObj.baseResponses
                            : baseResObj.baseResponses.map(item => ({ baseRes: item.baseRes || "" }))
                      });
                    }
                  }

                  // Remove baseResponses from product before adding to sortedProducts
                  const { baseResponses, ...productWithoutBaseResponses } = product;
                  sortedProducts.push(productWithoutBaseResponses);
                  break;
                }
              }
            });

            discoveryCtx.updateCoreAttributes({
              ...commonReq,
              category_averages,
              products: sortedProducts,
              summary: coreAttributeSummary,
              baseResponses: baseResponsesArray,
              isValidated,
            });

            discoveryCtx.updateSources({
              res: sources,
              req: commonReq,
              showOldSourcesRecord,
              type: metricsRecord[type]
            });
          });
        }
        break;

      case "conversations":
        if (!response)
          return console.warn("Missing response for 'conversations'");

        discoveryCtx.updateConversations({
          data: response?.data || {},
          category: category,
          llm: llm,
          market: market,
          persona,
          request_id: data.id,
          created_at: data?.created_at,
          isValidated
        });
        break;

      case "contentMapping":
        if (!response)
          return console.warn("Missing response for 'contentMapping'");

        discoveryCtx.updateContentMapping({
          data: response || {},
          category: request?.category,
          llm: request?.llm,
          request_id: data.id
        });
        break;

      case "description":
        if (!response?.data)
          return console.warn("Missing response.data for description");
        discoveryCtx.updateBrandDescription({
          res: response.data,
          req: { category: category, llm: llm },
        });
        break;

      case "theme":
      case "snippet": {
        const isTheme = type === "theme";
        const snippetData = response?.data;

        if (!Array.isArray(response?.data?.data)) {
          console.warn(
            `${type} data not in expected array format:`,
            snippetData
          );
          return;
        }

        if (!llm || !category) {
          console.warn("Missing llm or category for theme/snippet");
          return;
        }

        const store = isTheme
          ? discoveryCtxRef.current?.brand_snippets
          : discoveryCtxRef.current?.brand_themes;

        const updateFn = isTheme
          ? discoveryCtx.updateBrandSnippets
          : discoveryCtx.updatedBrandThemes;

        const currentList = store?.[llm]?.[category] || [];
        const updatedList = [...currentList, snippetData];
        updateFn({
          res: updatedList,
          req: { category: category, llm: llm },
        });

        break;
      }

      default:
        console.warn(`Unhandled socket data type: ${type}`);
    }
  };

  let currentBrandSnippets = [];
  let currentBrandThemes = [];
  const coreAttributeMapRef = useRef({});
  const loadSocketData = (
    socketResponse,
    requestObj,
    currentTransactionId,
    showOldSourcesRecord
  ) => {
    if (!socketResponse || typeof socketResponse !== "object") {
      console.error("Invalid socket response:", socketResponse);
      return;
    }
    let {
      type,
      request,
      response,
      category,
      llm,
      market,
      persona,
      status,
      transactionId,
      isValidated,
    } = socketResponse;
    if (!type || !request) {
      console.error("Incomplete socket response:", response);
      return;
    }
    if (status !== "COMPLETED") {
      return false;
    }
    if (parseInt(transactionId) !== parseInt(currentTransactionId)) return;
    const onlyIfValidated = (data, empty = Array.isArray(data) ? [] : {}) => {
      if (showOldSourcesRecord) {
        if (Array.isArray(data)) return data;
        if (data == null) return [];
        return [data];
      }

      return isValidated ? data : empty;
    };
    const commonReq = {
      category: category,
      llm: llm,
      market: market,
      persona: persona
    };
    console.log("LoadBrandAuditData", response);
    switch (type) {
      case "rank":
        if (!response) return console.warn("Missing response for rank");
        response = { ...response, request_id: socketResponse.id, isValidated };
        const sourcesRank = onlyIfValidated(response?.sources?.rank || [], []);
        discoveryCtx.updateRankScores({
          req: commonReq,
          res: response,
        });
        discoveryCtx.updateSources({
          res: sourcesRank,
          req: commonReq,
          showOldSourcesRecord,
          type: metricsRecord[type]
        });
        break;

      case "sentiment":
        if (!response)
          return console.warn("Missing response/Transaction for sentiment");

        // const entity = response?.data?.[0];
        const entity = { ...response?.data }?.[0];
        const sentimentSources = onlyIfValidated(
          response?.sources?.sentiment || [],
          []
        );
        const updatedExtras = !showOldSourcesRecord
          ? updateValidatedSources(response.extras)
          : response.extras;
        const brandRes = response?.error
          ? { error: "something went wrong" }
          : {
            name: entity?.name || "Unknown",
            favorability: entity?.score ?? 0,
            extras: updatedExtras,
            sentimentSources,
            isValidated,
            rbiType: response?.rbiType,
          };

        let index = -1;
        try {
          requestObj.competitor?.[request.category]?.forEach((item, idx) => {
            if (item.name?.toLowerCase() == entity?.name?.toLowerCase()) {
              index = idx;
            }
          });
          if (requestObj.brand === entity?.name) index = -1;
        } catch (err) {
          console.warn("Error calculating sentiment index:", err);
        }

        discoveryCtx.updateBrandScores({
          req: commonReq,
          res: { data: brandRes, index: index + 1 },
          sentimentSources,
          isValidated,
        });
        discoveryCtx.updateSources({
          res: sentimentSources,
          req: commonReq,
          showOldSourcesRecord,
          type: metricsRecord[type]
        });
        break;

      case "signalStrength":
        if (!response) return console.warn("Missing response for signalStrength");
        const negativeAttributes = response?.aggregatedNegatives || [];
        const positiveAttributes = response?.aggregatedPositives || [];

        let sourcesPositiveArray = onlyIfValidated(
          response?.aggregatedPositiveSources || [],
          []
        );
        let sourcesNegativeArray = onlyIfValidated(
          response?.aggregatedNegativeSources || [],
          []
        );
                    console.log("showOldSourcesRecord",showOldSourcesRecord,sourcesPositiveArray)

        if (showOldSourcesRecord) {
          // v4's live signalStrength push sends each entry as a single already-merged
          // {url: count, ...} map (wrapped one-per-array-item), not one object per URL —
          // pass those through unchanged instead of reading a nonexistent .url/.count off
          // the whole map. Still handles the {url, count, http_status}-per-entry shape and
          // genuinely old plain-string entries, in case either is ever sent here too.
          sourcesPositiveArray = sourcesPositiveArray.map(toOldSourcesEntry);
          sourcesNegativeArray = sourcesNegativeArray.map(toOldSourcesEntry);
        }

        discoveryCtx.updatePositiveNegativeAttributes({
          res: {
            name: socketResponse?.brand,
            positives: positiveAttributes,
            negatives: negativeAttributes,
          },
          req: commonReq,
        });

        discoveryCtx.updateSources({ res: sourcesPositiveArray, req: commonReq, showOldSourcesRecord, type: "Positive Attributes" });
        discoveryCtx.updateSources({ res: sourcesNegativeArray, req: commonReq, showOldSourcesRecord, type: "Negative Attributes" });
        break;

      case "categoryDimension":
        if (!response)
          return console.warn("Missing response for categoryDimension");
        const normalize = (src) =>
          Array.isArray(src)
            ? onlyIfValidated(src, [])
            : onlyIfValidated(src ? [src] : [], []);

        const sourcesCategory = normalize(response?.sources?.category);
        const sourcesDim = normalize(response?.sources?.dimension);

        const sourcesCategoryDim = [...sourcesCategory, ...sourcesDim];
        discoveryCtx.updateCategoryDimensions({
          ...commonReq,
          data: response?.data,
          summary: response?.summary,
          sources: sourcesCategory,
          baseResponses: { ...(response?.baseResponses || {}), multi_prompting: response?.multi_prompting || false, num_runs: response?.num_runs },
          isValidated,
        });

        discoveryCtx.updateSources({
          res: sourcesCategoryDim,
          req: commonReq,
          showOldSourcesRecord,
          type: metricsRecord[type]
        });
        break;

      case "taxonomy":
        if (!response) return console.warn("Missing response for taxonomy");
        response = { ...response, isValidated };
        discoveryCtx.updatedTaxonomies({
          res: response,
          req: commonReq
        });
        break;

      case "core-attribute":
        if (!response || !category || !llm)
          return console.warn("Missing data for core-attribute");

        const key = `${llm}__${category}_${persona}`;

        if (!coreAttributeMapRef.current[key]) {
          coreAttributeMapRef.current[key] = [];
        }

        const newProductName = (
          response?.brandName ||
          response?.products?.[0]?.name ||
          ""
        )
          ?.toLowerCase()
          .trim();
        const alreadyExists = coreAttributeMapRef.current[key].some(
          (item) =>
            (item?.brandName || item?.products?.[0]?.name || "")
              ?.toLowerCase()
              .trim() === newProductName
        );

        if (!alreadyExists && newProductName) {
          coreAttributeMapRef.current[key].push(response);
        }

        let competitors = requestObj?.competitor?.[category]?.map(
          (item) => item.name
        );
        let brand = requestObj?.competitor?.["default"]?.[0].name;
        if (competitors) {
          competitors.unshift(brand);
        } else {
          competitors = [];
        }

        const expectedCount =
          (requestObj?.competitor?.['default']?.length ?? 0) +
          (requestObj?.competitor?.[category]?.length ?? 0);

        if (coreAttributeMapRef.current[key].length === expectedCount) {
          const group = coreAttributeMapRef.current[key];
          let coreAttributeSummary = "";
          const products = [];
          const sources = [];

          const category_averages = group[0]?.category_averages;

          for (const res of group) {
            if (!res?.error && Array.isArray(res?.products)) {
              coreAttributeSummary += res.products?.[0]?.summary || "";
              coreAttributeSummary += "\n\n";
              const productSources = onlyIfValidated(
                res?.sources?.product || [],
                []
              );
              products.push({
                ...res.products?.[0],
                brandName: res.brandName,
                sources: productSources,
                baseResponses: res.baseResponses || null,
                multi_prompting: res.multi_prompting || false,
                num_runs: res.num_runs,
              });
              if (showOldSourcesRecord || isValidated) {
                const normalize = (src) =>
                  Array.isArray(src) ? src : src ? [src] : [];

                const categorySources = normalize(res?.sources?.category);
                const productSources = normalize(res?.sources?.product);

                sources.push(...categorySources, ...productSources);
              }
            }
          }

          let sortedProducts = [];
          let baseResponsesArray = [];
          for (const company of competitors) {
            const normalizedCompany = company.toLowerCase().replace(/\s+/g, "");
            for (const product of products) {
              const normalizedProductName = (
                product?.brandName ||
                product?.name ||
                ""
              )
                ?.toLowerCase()
                ?.replace(/\s+/g, "");
              if (normalizedProductName === normalizedCompany) {
                // Extract baseResponses and add to separate array
                if (product.baseResponses && typeof product.baseResponses === 'object') {
                  const baseResObj = product.baseResponses;
                  if (baseResObj.baseResponses && Array.isArray(baseResObj.baseResponses)) {
                    const firstItem = baseResObj.baseResponses[0];
                    const isPerAttributeMulti = firstItem?.attribute != null && Array.isArray(firstItem?.runs);
                    const isFlatRunMulti = firstItem?.run != null && firstItem?.baseRes != null && baseResObj.baseResponses.length > 1;
                    const isMultiPrompting = product.multi_prompting === true || isPerAttributeMulti || isFlatRunMulti;
                    baseResponsesArray.push({
                      brandName: product.brandName,
                      basePrompt: baseResObj.basePrompt || "",
                      multi_prompting: isMultiPrompting,
                      num_runs: product.num_runs || (isPerAttributeMulti ? firstItem?.runs?.length : undefined),
                      baseResponse: isPerAttributeMulti
                        ? baseResObj.baseResponses
                        : isFlatRunMulti
                          ? baseResObj.baseResponses
                          : baseResObj.baseResponses.map(item => ({ baseRes: item.baseRes || "" }))
                    });
                  }
                }

                // Remove baseResponses from product before adding to sortedProducts
                const { baseResponses, ...productWithoutBaseResponses } = product;
                sortedProducts.push(productWithoutBaseResponses);
                break;
              }
            }
          }

          discoveryCtx.updateCoreAttributes({
            category_averages,
            products: sortedProducts,
            summary: coreAttributeSummary,
            baseResponses: baseResponsesArray,
            ...commonReq,
            isValidated,
          });
          discoveryCtx.updateSources({
            res: sources,
            req: commonReq,
            showOldSourcesRecord,
            type: metricsRecord[type]
          });
          delete coreAttributeMapRef.current[key];
        }
        break;

      case "conversations":
        if (!response)
          return console.warn("Missing response for 'conversations'");
        discoveryCtx.updateConversations({
          data: response || {},
          category: category,
          llm: llm,
          market: market,
          persona,
          request_id: socketResponse.id,
          created_at: socketResponse?.created_at,
          conversation_id: socketResponse?.conversationID,
          conversationStatus: socketResponse?.conversationStatus,
          isValidated
        });
        break;

      case "contentMapping":
        if (!response)
          return console.warn("Missing response for 'contentMapping'");

        discoveryCtx.updateContentMapping({
          data: response || {},
          category: request?.category,
          llm: request?.llm,
          request_id: socketResponse.id
        });
        break;
      case "description":
        if (!response?.data)
          return console.warn("Missing response.data for description");
        discoveryCtx.updateBrandDescription({
          res: response.data,
          req: { category: category, llm: llm },
        });
        break;

      case "theme":
      case "snippet":
        const isTheme = type === "theme";
        const dataSnippet = response?.data;

        if (!Array.isArray(response?.data?.data)) {
          console.warn(`${type} response is not a valid array:`, dataSnippet);
          return;
        }

        if (!llm || !category) {
          console.warn("Missing llm/category for", type);
          return;
        }

        const targetStore = isTheme ? currentBrandSnippets : currentBrandThemes;
        const contextMethod = isTheme
          ? discoveryCtx.updateBrandSnippets
          : discoveryCtx.updatedBrandThemes;

        if (!targetStore[llm]) targetStore[llm] = {};
        if (!targetStore[llm][category]) targetStore[llm][category] = [];

        // Append entire array as a sub-array
        targetStore[llm][category] = [
          ...targetStore[llm][category],
          dataSnippet,
        ];

        contextMethod({
          res: targetStore[llm][category],
          req: { category, llm },
        });
        break;

      default:
        console.warn(`Unhandled socket data type: ${type}`);
    }
  };

  function tabChangeHandler(val) {
    setTabSelected(val);
  }

  const extractPersonaTitles = (personas = []) =>
    personas.map(p => (typeof p === "string" ? p : p?.title)).filter(Boolean);


  useEffect(() => {
    const searchParams = new URLSearchParams(location.search);
    const id = searchParams.get("id");
    const type = searchParams.get("type");
    const user_id = searchParams.get("user_id");
    const urlCustomerId = searchParams.get("customer_id");
    if (urlCustomerId && String(user?.user_role?.user_id) === String(user_id)) {
      setSelectedCustomerById(Number(urlCustomerId));
    }
    if (id && type && user_id && !cancelTransaction) {
      // Deep-linked from Home Page - New's "View full Brand Audit" — show a
      // loading state over this tab until the specific record arrives,
      // instead of the default "new brand audit" form flashing first.
      setExternalReportLoading(true);
      loadBrandAudit(id, type, user_id, false);
    }
    if (discoveryCtx.abort_launch) {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
      if (rankScoreAbortCtrRef.current) {
        rankScoreAbortCtrRef.current.abort();
      }
    }
  }, [discoveryCtx.abort_launch]);

  async function loadBrandAudit(
    id,
    type,
    user_id,
    refreshRecord = false,
    isTabChange = false,
    isUpdateFormData = true
  ) {
    try {
      api
        .get(`${webSocketBaseURL}/transaction/brandAudit/${user_id}/${id}`)
        .then((response) => {
          if (response?.data?.transactionStatus !== "PENDING") {
            const transactionId = parseInt(id);
            if (refreshRecord) {
              currentBrandSnippets = [];
              currentBrandThemes = [];
              coreAttributeMapRef.current = {};
              discoveryCtx.refreshState();
            } else {
              const completedTests = response?.data?.testIds.filter(t => t.status !== "INACTIVE");
              const transactionIdIndex = completedTests.findIndex(
                t => t.transactionId === transactionId
              );
              setActiveTab(transactionIdIndex);
              setDomain(response?.data?.brandDomainName);
              discoveryCtx.resetState();
              response?.data?.testIds
                .map((item, originalIndex) => ({ ...item, originalIndex }))
                .filter(item => item.status !== "INACTIVE")
                .forEach(item => {
                  if (response?.data?.finalTransactionId === item.transactionId) {
                    discoveryCtx.updateLaunchRecord({
                      name: `Final ${ENTITY_LABELS.audit}`,
                      transactionId: item.transactionId,
                    });
                  } else {
                    discoveryCtx.updateLaunchRecord({
                      name: `Test ${ENTITY_LABELS.audit} ${item.originalIndex + 1}`,
                      transactionId: item.transactionId,
                      totalTestAudit: response?.data?.testIds?.length
                    });
                  }
                });
              discoveryCtx.updateFinalTransactionId(
                response?.data?.finalTransactionId
              );
              discoveryCtx.updateFinalTransactionStatus(
                response?.data?.finalTransactionIdStatus
              );
            }
            let {
              transactionStatus,
              completedTaskCount,
              totalCount,
              userMetricSettingId,
              sourceValidationStatus,
              brandAuditLimits,
              is_shared,
              shared_at,
              owner_user_id
            } = response?.data || {};
            if (transactionStatus === "RUNNING" && isTabChange) {
              startPolling(transactionId, type);
              discoveryCtx.updateLoading(true);
              setIsAuditRunning(true);
            }
            discoveryCtx.updateLaunch(brandAuditLimits);
            discoveryCtx.updateType(type);
            discoveryCtx.updateTransactionId(id);
            discoveryCtx.updateId(id);
            discoveryCtx.updatedLaunched(true);
            discoveryCtx.updateTransactionStatus(transactionStatus);
            discoveryCtx.updateSourceValidationStatus(sourceValidationStatus);
            discoveryCtx.updateShareInfo({ is_shared, shared_at, owner_user_id });
            discoveryCtx.updateCustomTemplateID(userMetricSettingId || null);
            discoveryCtx.setMetricSettingObj(
              response?.data?.user_metric_setting_object
            );

            if (
              (["COMPLETED", "RETRY"].includes(transactionStatus) ||
                completedTaskCount === totalCount) &&
              !isTabChange
            ) {
              getHistory(1, 5, type);
              setProcessRetry(false);
              stopPolling();
              discoveryCtx.updateLoading(false);
              setIsAuditRunning(false);
              discoveryCtx.updateLaunchTransaction(false);
            } else if (!isTabChange) {
              discoveryCtx.updateLoading(true);
              setIsAuditRunning(true);
            }
            discoveryCtx.updateStatus({ totalCount, completedTaskCount });
            let requestObj = response?.data?.task[0]?.request_object;
            if (!requestObj) return;
            let competitors = requestObj?.competitor;
            competitors["default"] = [
              {
                name: requestObj.brand,
                domain: requestObj.brandDomainName,
                variants: [],
                display_name: requestObj.brand,
              },
            ];
            discoveryCtx.updatePrimaryLLM(requestObj.primaryLLM);
            discoveryCtx.updateConversationEnabled(requestObj.conversation_enabled ?? false);
            discoveryCtx.updatedCompetitors(competitors);
            discoveryCtx.updateEntity(requestObj.brand);
            discoveryCtx.updateMarket(requestObj.market);
            discoveryCtx.updatePersona(
              requestObj?.persona?.length > 0
                ? requestObj?.persona
                : [{ title: "General Persona", description: "General Persona" }]
            );
            discoveryCtx.updateCategory(requestObj.category);
            const keys = ["applyPersonaToAllCategory", "applyPersonaToAllMarkets"];
            const personaSettings = keys.reduce((acc, key) => {
              acc[key] = requestObj?.[key] ?? false;
              return acc;
            }, {});

            discoveryCtx.updatePersonaSettings(personaSettings);
            discoveryCtx.updateSelectedLLM(requestObj.primaryLLM);
            discoveryCtx.updateLLM(requestObj.llm);
            discoveryCtx.updateFormData(isUpdateFormData);
            discoveryCtx.updateSelectedMarket(requestObj.market[0]);
            discoveryCtx.updateSelectedCategory(requestObj.category[0]);
            discoveryCtx.updateSelectedPersona(Array.isArray(requestObj?.persona) &&
              requestObj?.persona?.length > 0
              ? requestObj?.persona[0]?.title ?? requestObj?.persona[0]
              : "General Persona");
            discoveryCtx.updateName(`${requestObj.brand} ${ENTITY_LABELS.brand} Overview`)
            discoveryCtx.updateRbiType(requestObj.rbiType || "propensityToRecommend");
            if (requestObj?.conversationSettings) {
              discoveryCtx.updateConversationSetting(requestObj.conversationSettings);
            }
            if (requestObj.keywords) {
              discoveryCtx.updateKeywords(requestObj.keywords);
            }
            discoveryCtx.updateCategoryType(requestObj.categoryType || {});
            discoveryCtx.updateRankCompetitiveSet(requestObj.rank_competitive_set || {});
            discoveryCtx.updateRankMethodology(requestObj.rank_methodology || "by_category");
            discoveryCtx.cancelSelection();
            const showOldSourcesRecord = sourceValidationStatus === "PENDING";
            for (const record of response?.data.task) {
              loadSocketData(record, requestObj, id, showOldSourcesRecord);
            }
          }
        })
        .catch((error) => {
          console.error("API call failed:", error);
          if (error.message === "Network Error") {
            toast.warn("Please check your network connection");
          } else if (error.code === "ECONNABORTED") {
            toast.warn("Request timed out. Please try again");
          } else {
            toast.error(
              "Failed to load discovery report. Please check if URL is correct"
            );
          }
        })
        // Chained on the promise itself (not the outer try/finally below,
        // which runs synchronously right after the request is fired and
        // would clear the flag before the response ever arrives) so the
        // loading state actually lasts until this request settles.
        .finally(() => {
          setExternalReportLoading(false);
        });
    } catch (error) {
      toast.error(
        "Failed to load BrandAudit Data. Please check if URL is correct"
      );
      setExternalReportLoading(false);
    }
  }

  //start polling after discovery launch
  const startPolling = (transactionId, type) => {
    if (pollingRef.current) clearInterval(pollingRef.current);

    pollingRef.current = setInterval(() => {
      console.log("Calling transaction API...");
      loadBrandAudit(transactionId, type, user?.user_role?.user_id, true);
    }, 5 * 60 * 1000); // 5 minutes
  };
  const stopPolling = () => {
    if (pollingRef.current) {
      clearInterval(pollingRef.current);
      pollingRef.current = null;
      console.log("Stopped polling");
    }
  };

  const retryPolling = (transactionId, type) => {
    if (pollingRef.current) clearInterval(pollingRef.current);

    pollingRef.current = setInterval(() => {
      loadBrandAudit(transactionId, type, user?.user_role?.user_id, true);
    }, 1 * 60 * 1000); // 30 sec
  };

  useEffect(() => {
    return () => {
      if (pollingRef.current) clearInterval(pollingRef.current);
    };
  }, []);

  useEffect(() => {
    if (!inputValues.brand || !inputValues.category) return;
    // getCompetitors();

    return () => {
      if (abortControllerRef.current) {
        abortControllerRef.current.abort();
      }
    };
  }, [inputValues]);

  let coreAttributesSummary = "";
  let categoryDimensionsSummary = "";
  let productDimensionSummary = "";
  if (
    discoveryCtx?.core_attributes &&
    Object.keys(discoveryCtx?.core_attributes).length > 0
  ) {
    coreAttributesSummary = discoveryCtx.core_attributes.summary;
  }
  if (
    discoveryCtx?.category_dimensions &&
    Object.keys(discoveryCtx?.category_dimensions).length > 0
  ) {
    categoryDimensionsSummary = discoveryCtx.category_dimensions.summary;
  }

  if (
    discoveryCtx?.taxonomies &&
    Object.keys(discoveryCtx?.taxonomies).length > 0
  ) {
    productDimensionSummary = discoveryCtx.taxonomies.summary;
  }

  let competitors = discoveryCtx.competitors;

  const exportToPDF = useReactToPrint({
    contentRef: pdfRef,
    documentTitle: `${entity} Overview`,
    removeAfterPrint: true,
    pageStyle: `
      @page {
        size: 380mm 400mm;
        margin-left: 10mm;
        margin-right: 10mm;
        margin-bottom: 5mm;
        margin-top: 15mm;
      }
      @media print {
        body {
          -webkit-print-color-adjust: exact; /* Ensures accurate color printing */
        }
      }
    `,
  });

  async function retryBrandAudit() {
    try {
      const transactionId = discoveryCtx.state.transactionId;
      if (!transactionId)
        throw new Error("Invalid record: transactionId not found");
      getHistory();
      setProcessRetry(true);
      discoveryCtx.updateTransactionStatus("RUNNING");
      const response = await fetch(
        `${webSocketBaseURL}/retry-transaction-request/${transactionId}`
      );
      retryPolling(transactionId, discoveryCtx.type);
      return response?.data;
    } catch (error) {
      console.error("Retry API failed:", error);
      throw error;
    }
  }

  function ProgressIndicator({ total, completed }) {
    const progressPercentage = (completed / total) * 100;

    return (
      <div className={classes.progressIndicator}>
        <div className={classes.progressBar}>
          <div
            className={classes.progressFill}
            style={{
              width: `${progressPercentage}%`,
            }}
          ></div>
        </div>
        <div className={classes.progressText}>
          {completed} of {total} tasks completed
        </div>
      </div>
    );
  }

  const isTransientError = (err) => {
    if (!err || !err.response) return true;
    const { status } = err.response;
    // 404/409 are common before row/files exist; 429/5xx are transient
    return (
      status === 429 ||
      (status >= 500 && status <= 599) ||
      status === 404 ||
      status === 409
    );
  };

  const fetchAuditProgressOnce = async (id) => {
    const { data } = await api.get(`/llm-reporting/progress/${id}`);
    // { id, status, finalFilePath, totalSlides, generatedSlides, skippedUnits, messages, percent, ... }
    if (data?.status === "completed" || data?.status === "success") {
      setTimeout(() => {
        setAuditJobStatus(data.status);

      }, 1500);
    } else {
      setAuditJobStatus(data.status);

    }
    setAuditMessages(Array.isArray(data.messages) ? data.messages : []);
    const p = Number(data?.percent ?? 1);
    setAuditPercent(Math.max(1, Math.min(100, p)));
    return data;
  };

  const stopAuditPolling = () => {
    if (auditPollTimerRef.current) {
      clearTimeout(auditPollTimerRef.current);
      auditPollTimerRef.current = null;
    }
    if (auditInitialTimerRef.current) {
      clearTimeout(auditInitialTimerRef.current);
      auditInitialTimerRef.current = null;
    }
    auditConsecutiveFailuresRef.current = 0;
  };

  // const handleAuditTerminal = (data) => {
  //   if (!data) return;
  //   if (data.status === "completed" || data.status === "success") {
  //     setAuditPercent(100);
  //     stopAuditPolling();
  //     if (!downloadedForJobRef.current) {
  //       downloadedForJobRef.current = data.id;
  //       // Same-origin download URL
  //       const dl = `${process.env.REACT_APP_BASE_URL}/llm-reporting/download/${data.id}`;
  //       window.location.assign(dl);
  //     }
  //   } else if (data.status === "failed") {
  //     stopAuditPolling();
  //   }
  // };

  const handleAuditTerminal = async (data) => {
    if (!data) return;
    if (data.status === "completed" || data.status === "success") {
      setAuditPercent(100);
      stopAuditPolling();
      if (!downloadedForJobRef.current) {
        downloadedForJobRef.current = data.id;

        const filename =
          discoveryType === "brand"
            ? `brand-${ENTITY_LABELS.audit.toLowerCase()}-report.pptx`
            : `product-${ENTITY_LABELS.audit.toLowerCase()}-report.pptx`;

        // Use the downloadFile helper which includes authentication
        const result = await downloadFile(
          `/llm-reporting/download/${data.id}`,
          `${filename}` // or whatever filename you want
        );
        if (!result.success) {
          toast.error("Failed to download report. Please try again later.");
        } else if (result.success) {
          console.log("File downloaded successfully");
          setLoading(false);
          toast.success("Report downloaded successfully");
        }
      }
    } else if (data.status === "failed") {
      stopAuditPolling();
    }
  };

  const pollAuditProgress = (id) => {
    stopAuditPolling(); // reset any existing timers
    let consecutiveFailures = 0;

    const scheduleNext = (delayMs) => {
      if (auditPollTimerRef.current) clearTimeout(auditPollTimerRef.current);
      auditPollTimerRef.current = setTimeout(run, delayMs);
    };

    const run = async () => {
      try {
        const data = await fetchAuditProgressOnce(id);
        consecutiveFailures = 0;
        handleAuditTerminal(data);
        if (data.status === "running" || data.status === "pending") {
          scheduleNext(15000); // 15s cadence
        }
      } catch (err) {
        const transient = isTransientError(err);
        consecutiveFailures += 1;
        if (!transient || consecutiveFailures >= 3) {
          stopAuditPolling();
          setAuditJobStatus("failed");
          return;
        }
        // backoff + jitter
        const base = 800 * Math.pow(2, consecutiveFailures - 1);
        const jitter = Math.floor(Math.random() * 200);
        scheduleNext(base + jitter);
      }
    };

    // small warm-up so backend can persist job row
    auditInitialTimerRef.current = setTimeout(run, 1200);
  };

  useEffect(() => {
    if (
      auditJobStatus === "completed" &&
      auditJobId &&
      downloadedForJobRef.current !== auditJobId
    ) {
      // Show success message before download
      toast.success("Report generated successfully!", {
        autoClose: 3000,
      });
    }
  }, [auditJobStatus, auditJobId]);

  async function generateReport(request_type) {
    let { transactionHistory, transactionId } = discoveryCtx.state;

    const isReporting = window.location.search.includes('isReporting=true');

    let auditRunDate =
      transactionHistory.find((ele) => ele.transactionId === transactionId)
        ?.start_time ?? new Date();

    let date = new Date(auditRunDate);
    const shortMonth = date.toLocaleString("en-US", { month: "short" });

    let dateFormate = ` ${shortMonth} ${date.getDate()}, ${date.getFullYear()}`;

    try {
      const primaryLLM = LLM_OPTIONS.find(
        (opt) => opt.value === discoveryCtx.primary_llm
      )?.name;
      const otherllm = discoveryCtx.llm
        .map((val) => LLM_OPTIONS.find((opt) => opt.value === val)?.name)
        .filter((name) => name && name !== primaryLLM);
      const uniqueCompetitorBrands = {};

      (discoveryCtx?.category ?? []).forEach((cat) => {
        const names = discoveryCtx?.competitors?.[cat]?.map(c => c.name) ?? [];
        uniqueCompetitorBrands[cat] = [entity, ...names];
      });

      setLoading(true);
      const frontend_build_version = localStorage.getItem(
        "frontend_build_version"
      );

      let competitorsCategoryWise =
        Object.entries(discoveryCtx?.competitors ?? {})?.reduce((pre, cur) => {
          pre[cur[0]] = cur?.[1]?.length ?? 0;
          return pre;
        }, {}) ?? {};

      const LLMsListWithActualName =
        discoveryCtx?.llm.map((key) => OVERVIEW_LLM_LABELS?.[key] ?? key) ?? [];
      const token = localStorage.getItem("token");
      const user = localStorage.getItem("user");
      const payload = {
        isBrand: discoveryType === "brand",
        request_type: request_type ?? "brand-audit",
        transactionID: discoveryCtx.state.transactionId,
        brand: entity,
        category: discoveryCtx.category,
        // rbiType: values.rbiType,
        primaryCategory: discoveryCtx.category[0],
        primaryLLM: discoveryCtx.primary_llm,
        primaryMarket: discoveryCtx.markets[0],
        market: discoveryCtx.markets[0],
        llm: otherllm,
        llmActualName: OVERVIEW_LLM_LABELS,
        llmList: discoveryCtx?.llm ?? [],
        uniqueCompetitorBrands,
        Markets: discoveryCtx.markets,
        Categories: discoveryCtx.category,
        Persona: extractPersonaTitles(discoveryCtx.persona),
        competitorsCategoryWise,
        LLMs: LLMsListWithActualName,
        date: dateFormate,
        frontend_build_version,
        selectedSection: Object.values(discoveryCtx?.state?.selectedSection),
        tab: tab,
        filter: filterKey,
        token,
        user,
        selectAll: discoveryCtx?.state?.selectAll,
        personaSetting: discoveryCtx?.state?.personaSettings,
        regenerateReport: isReporting
          // || process.env.REACT_APP_BASE_URL.includes("localhost")
          ? true : false,
      };
      console.log("payload print...", payload);
      // const blob = await api.post(
      //   "/llm-reporting/generate/brandaudit",
      //   payload,
      //   {
      //     responseType: "blob",
      //   }
      // );
      // const url = window.URL.createObjectURL(blob.data);
      // const a = document.createElement("a");
      // a.href = url;
      // a.download = "BrandAudit.pptx";
      // document.body.appendChild(a);
      // a.click();
      // window.URL.revokeObjectURL(url);

      // const res = await api.post("/llm-reporting/generate/brandaudit", payload);
      // const { jobId } = res.data || {};
      //       const downloadUrl = getReportDownloadUrl(jobId);
      //       if (downloadUrl && jobId) {
      //         window.location.assign(downloadUrl);
      //       } else {
      //         throw new Error("No JobId returned");
      //       }

      // Show bar immediately while we wait for jobId
      setAuditJobId(null);
      setAuditJobStatus("pending"); // NEW state
      setAuditPercent(1);
      setAuditMessages([]);
      downloadedForJobRef.current = null;
      const res = await api.post("/llm-reporting/generate/brandaudit", payload);
      const { jobId } = res.data || {};
      if (!jobId) throw new Error("No JobId returned");
      setAuditJobId(jobId);
      setAuditJobStatus("pending");
      setAuditPercent(1);
      // Start polling (15s cadence with backoff)
      // setTimeout(() => {
      //   pollAuditProgress(jobId);

      // }, 3000);
      pollAuditProgress(jobId);
    } catch (error) {
      setLoading(false);
      setAuditJobStatus(null);
      setAuditPercent(0);
    }
  }

  const pollJobProgress = async (jobId) => {
    const maxAttempts = 60; // 15 minutes with 15 second intervals
    const pollInterval = 15000; // 15 seconds
    let attempts = 0;

    while (attempts < maxAttempts) {
      try {
        const progressRes = await api.get(`/llm-reporting/progress/${jobId}`);
        const { status } = progressRes.data;

        console.log(`Checking report status: ${status}`);

        if (status === "completed" || status === "success") {
          return { success: true, data: progressRes.data };
        }

        if (status === "failed") {
          return { success: false, error: "Report generation failed" };
        }

        // Wait 15 seconds before next poll
        await new Promise(resolve => setTimeout(resolve, pollInterval));
        attempts++;
      } catch (error) {
        console.error("Error polling job progress:", error);

        // Retry on network errors
        if (attempts < 3) {
          await new Promise(resolve => setTimeout(resolve, pollInterval));
          attempts++;
          continue;
        }
        throw error;
      }
    }

    throw new Error("Report generation timed out after 15 minutes");
  };

  // const openHtmlReport = async (selections) => {

  //   const transactionId = discoveryCtx.state.transactionId;
  //   const userId = user?.user_role?.user_id;
  //   const type = discoveryType;
  //   setHtmlReportLoading(true);
  //   try {
  //     // // 1️⃣ Open blank tab immediately (avoids popup blocker)
  //     // const newTab = window.open("", "_blank");

  //     // if (!newTab) {
  //     //   alert("Popup blocked. Please allow popups for this site.");
  //     //   return;
  //     // }

  //     // // Optional loading message
  //     // newTab.document.write("<h3 style='font-family:sans-serif'>Generating presentation...</h3>");


  //     const response = await api.post(
  //       "/llm-reporting/generateBrandAuditHTMLReport",
  //       {
  //         // params: { transactionId, userId, format: 'docx', type }
  //         transactionId,
  //         userId,
  //         format: 'html',
  //         type,
  //         selections
  //       }
  //     );

  //     const data = response.data || {};

  //     if (!data?.html) {
  //       throw new Error("Invalid HTML response");
  //     }

  //     // // 3️⃣ Render returned HTML
  //     // newTab.document.open();
  //     // newTab.document.write(data.html);
  //     // newTab.document.close();
  //     // ✅ Create downloadable file
  //     const blob = new Blob([data.html], { type: "text/html" });
  //     const url = window.URL.createObjectURL(blob);

  //     // ✅ Create temporary anchor
  //     const a = document.createElement("a");
  //     a.href = url;

  //     // You can dynamically set file name
  //     a.download = `Brand-Audit-Presentation-${transactionId}.html`;

  //     document.body.appendChild(a);
  //     a.click();

  //     // Cleanup
  //     document.body.removeChild(a);
  //     window.URL.revokeObjectURL(url);

  //   } catch (error) {
  //     console.error("Error loading report:", error);
  //     alert("Failed to generate presentation.");
  //   } finally {
  //     setHtmlReportLoading(false);
  //   }
  // };

  // openHtmlReport removed — HTML Report generation is handled by HTMLReportTab component



  const downloadDocxReport = async (selections) => {
    console.log("Selections:== ", selections);

    const transactionId = discoveryCtx.state.transactionId;
    const userId = user?.user_role?.user_id;
    const type = discoveryType;

    setReportLoading(true);

    try {
      // Step 1: Initiate report generation
      const initiateRes = await api.post(
        "/llm-reporting/generateBrandAuditSummaryWordReport",
        {
          // params: { transactionId, userId, format: 'docx', type }
          transactionId,
          userId,
          format: 'docx',
          type,
          selections
        }
      );

      const { jobId, } = initiateRes.data;

      if (!jobId) {
        throw new Error("No job ID received from server");
      }

      // toast.info('Generating report... This may take 10-15 minutes. You can continue working while we prepare your report.');

      // Step 2: Poll for completion (no progress callback)
      const pollResult = await pollJobProgress(jobId);

      if (!pollResult.success) {
        throw new Error(pollResult.error || "Report generation failed");
      }

      // Step 3: Download using the same pattern as PPT
      const result = await downloadFile(
        `/llm-reporting/download/${jobId}`,
        `Brand_Audit_Summary_Report_${transactionId}.docx`
      );

      if (!result.success) {
        throw new Error(result.error || 'Download failed');
      }
      toast.success('Summary Report downloaded successfully');

    } catch (err) {
      console.error('Error downloading summary report', err);

      let errorMessage = 'Error downloading summary report';

      if (err.message?.includes('timed out')) {
        errorMessage = 'Report generation is taking longer than expected. Please try again later.';
      } else if (err.response?.data?.error) {
        errorMessage = err.response.data.error;
      } else if (err.message) {
        errorMessage = err.message;
      }

      toast.error(errorMessage);
    } finally {
      setReportLoading(false);
    }
  };

  const brandAuditCall = async (values) => {
    const marketArray =
      Array.isArray(values.market) && values.market.length > 0
        ? values.market
        : ["General Market"];
    const persona =
      Array.isArray(values.persona) && values.persona.length > 0
        ? values.persona
          .map(p => {
            if (typeof p === "string") {
              return { title: p, description: p };
            }
            if (typeof p === "object" && p?.title) {
              return p;
            }
            return null;
          })
          .filter(Boolean)
        : [{ title: "General Persona", description: "General Persona" }];

    if (values?.competitorsData?.hasOwnProperty("default")) {
      delete values.competitorsData.default;
    }
    let resolvedDomain = values.domain || "";
    if (values.brand && !resolvedDomain) {
      try {
        if (discoveryCtx.type === "product") {
          const res = await validateProductInputValue(values.brand, undefined, values.category?.[0] || values.category);
          resolvedDomain = res?.data?.data?.domain || "";
        } else {
          const res = await validateBrandInputValue(values.brand, undefined, values.category?.[0] || values.category);
          resolvedDomain = res?.data?.data?.domain || "";
        }
        if (resolvedDomain) {
          discoveryCtx.updatedCompetitors({
            ...discoveryCtx.competitors,
            default: [{ name: values.brand, domain: resolvedDomain }],
          });
        }
      } catch {
        resolvedDomain = "";
      }
    }

    // let category_taxonomies;
    // if (discoveryCtx.type == "product") {
    //   category_taxonomies =
    //     discoveryCtx.category_taxonomies ?? discoveryCtx.category_taxonomies;
    // }
    const payload = {
      user_id: user?.user_role?.user_id,
      brand: values?.brand?.trim(),
      market: marketArray,
      type: discoveryCtx.type,
      llm: values.llm,
      category: values.category,
      persona,
      primaryMarket: values.market[0],
      primaryLLM: values.primaryLLM,
      competitor: values.competitorsData,
      rbiType: values.rbiType,
      request_type: "brandAudit",
      shouldProcessImmediately: "true",
      isMock: values.isMock,
      brandDomainName: resolvedDomain || "example.com",
      // customTaxonomy: category_taxonomies,
      user_metric_setting_id: values.metricSettingId,
      customerId: user?.customer_id || 0,
      // industry_customer_id: selectedCustomerId,
      run_type: launchType,
      final_transaction_id: discoveryCtx.state.finalTransactionId || null,
      categoryWiseMetric: values.categoryWiseMetric,
      categoryType: values.categoryType,
      ...(values.rankCompetitiveSet && Object.keys(values.rankCompetitiveSet).length
        ? { rank_competitive_set: values.rankCompetitiveSet }
        : {}),
      ...(user?.is_custom_rank
        ? { rank_methodology: values.rankMethodology || "by_category" }
        : {}),
      is_custom_rank: !!user?.is_custom_rank,
      is_non_branded_questions: !!values.isNonBrandedQuestions,
      is_fact_based_questions: !!values.isFactBasedQuestions,
      conversation_enabled: launchType === "final" || (launchType === "test" && enableTestConvoContentMap),
      enableTestBrandAuditConversationContentMapping: enableTestConvoContentMap,
      keywords: values.keywords,
      ...((launchType === "final" || (launchType === "test" && enableTestConvoContentMap)) && { conversationSettings: values.conversationSettings }),
      ...(values.isBatchMode && Array.isArray(values?.llm) && values.llm.length
        ? { llmBatchConfig: Object.fromEntries(values.llm.map((l) => [l, true])) }
        : {}),
      ...values.personaSettings
    };
    try {
      const response = await api.post(
        `${webSocketBaseURL}/brand-audit`,
        payload
      );
      getHistory();
      const transactionId = response?.data?.transaction_id;
      const finalTransactionId = response?.data?.final_transaction_id;
      const totalCount = response?.data?.totalCount;
      const user_metric_setting_object =
        response?.data?.user_metric_setting_object ?? {};
      if (transactionId) {
        startPolling(transactionId, discoveryCtx.type);
        discoveryCtx.updateStatus({ totalCount, completedTaskCount: 0 });
        discoveryCtx.updateLaunchRecord({ transactionId });
        discoveryCtx.setMetricSettingObj(user_metric_setting_object);
        discoveryCtx.updateTransactionStatus("RUNNING");
        launchType === "final" &&
          discoveryCtx.updateSourceValidationStatus("RUNNING");
      }
      if (showLaunchMessage !== "true" && launchType === "final") {
        setShowLunchDialog(true);
      }
      discoveryCtx.updateTransactionId(transactionId);
      discoveryCtx.updateFinalTransactionId(finalTransactionId);
      discoveryCtx.updateId(transactionId);
      if (!transactionId) {
        console.error("Transaction ID not returned");
        return;
      }
    } catch (error) {
      console.log("responseBrandAudit", error);
    }
  };

  const selectReportSection = () => {
    discoveryCtx.showReportCheckbox(true);
  };

  const handleTabChange = (event, selectedTab) => {
    stopPolling();
    const data = discoveryCtx?.state?.launchRecord[selectedTab];
    setActiveTab(selectedTab);
    setDashbaordActiveTab(0);
    loadBrandAudit(
      data?.transactionId,
      discoveryCtx?.type,
      user?.user_role?.user_id,
      true,
      true
    );
    window.dispatchEvent(new Event("resize"));
    window.dispatchEvent(new Event("tabchange"));
  };

  const isHTMLReportTabActive = (() => {
    const showMarketTab = Array.isArray(discoveryCtx?.markets) && discoveryCtx.markets.length > 1;
    const showPersonaTab = Array.isArray(discoveryCtx?.persona) && discoveryCtx?.persona?.length > 1;
    const overviewTabCount = 2 + (showMarketTab ? 1 : 0) + (showPersonaTab ? 1 : 0);
    const catLen = discoveryCtx.category?.length || 0;
    const convoIdx = overviewTabCount + catLen;
    const htmlReportTabIndex = discoveryCtx.conversationEnabled ? convoIdx + 2 : convoIdx;
    return !!enableHTMLReport && dashbaordActiveTab === htmlReportTabIndex;
  })();

  console.log("AuditContextData", discoveryCtx);
  return (
    <>
      {externalReportLoading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1300,
            background: "rgba(255, 255, 255, 0.72)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 12,
          }}
        >
          <LinearProgress style={{ position: "fixed", top: 0, left: 0, right: 0 }} />
          <CircularProgress size={36} />
          <span style={{ fontSize: 13, fontWeight: 600, color: "#4a5875" }}>Loading {ENTITY_LABELS.brand.toLowerCase()} {ENTITY_LABELS.audit.toLowerCase()}…</span>
        </div>
      )}
      <section>
        {launchText && <Header actionText={launchText} hoverText={hoverText} actionVariant="text" />}
        <div className={classes.page_wrapper}>

          <div className={classes.container}>
            <div className={classes.content}>
              <Tabs
                options={[]}
                onChange={tabChangeHandler}
                selected={tabSelected}
              />
              <Form
                warningText={warningText}
                setWarningText={setWarningText}
                cancelTransaction={cancelTransaction}
                setCancelTransaction={setCancelTransaction}
                stopPolling={stopPolling}
                discoveryTypeChange={discoveryTypeChange}
                setDiscoveryTypeChange={setDiscoveryTypeChange}
                setLaunchType={setLaunchType}
                setDomain={setDomain}
                domain={domain}
                launchType={launchType}
                isAuditRunning={isAuditRunning}
                setIsAuditRunning={setIsAuditRunning}
                loadBrandAudit={loadBrandAudit}
                setActiveTab={setActiveTab}
                startPolling={startPolling}
                processRetry={processRetry}
                id="discovery"
                onReset={() => {
                  setInputValues((prevValues) => {
                    return {
                      ...prevValues,
                      brand: "",
                      category: "",
                      market: "",
                      llm: "",
                    };
                  });
                  setWarningText("");
                }}
                onSubmit={(values) => {
                  if (launchesRemaining == 0 && !isSpecial) {
                    toast.warn(
                      `You have reached your ${launchLimitFrequency} limit`
                    );
                    return;
                  }
                  if (!isSpecial) {
                    updateLaunches(values.personaMap);
                  } else {
                    updatePersonasOnly(values.personaMap);
                  }
                  if (externalReportLoading) return;
                  let competitors = {
                    ...values.competitorsData,
                    default: [{ name: values.brand, domain: values.domain || "example.com" }],
                  };
                  discoveryCtx.refreshState();
                  discoveryCtx.updateEntity(values.brand);
                  discoveryCtx.updatedCompetitors(competitors);
                  discoveryCtx.updatePersonaSettings(values.personaSettings)
                  discoveryCtx.updateRbiType(values.rbiType || "propensityToRecommend");
                  discoveryCtx.updateKeywords(values.keywords);
                  discoveryCtx.updateMarket(
                    values.market.length > 0 ? values.market : ["General Market"]
                  );
                  discoveryCtx.updatePersona(
                    values.persona.length > 0 ? values.persona : [{ title: "General Persona", description: "General Persona" }]
                  );
                  discoveryCtx.updateCategory(values.category);
                  if (launchType === "final") {
                    values.llm = values.llm.filter(
                      (item) => item !== testLLMModel
                    );
                  } else {
                    values.llm = [testLLMModel];
                  }
                  discoveryCtx.updateCustomTemplateID(values.metricSettingId === "default" ? null : values.metricSettingId);
                  discoveryCtx.updateLLM(values.llm);
                  discoveryCtx.updateSelectedLLM(values.primaryLLM);
                  discoveryCtx.updateSelectedMarket(
                    values.market.length > 0
                      ? values.market[0]
                      : ["General Market"]
                  );
                  discoveryCtx.updateSelectedCategory(values?.category[0]);
                  discoveryCtx.updateSelectedPersona(values?.persona[0]?.title ?? values?.persona[0]);
                  discoveryCtx.updateType(discoveryCtx.type);
                  discoveryCtx.updateName(`${values.brand} Brand Overview`);
                  discoveryCtx.updatePrimaryLLM(values.primaryLLM);
                  const launchRecord = discoveryCtx.state.launchRecord;
                  const totalTestAudit =
                    launchRecord?.length > 0
                      ? launchRecord[launchRecord.length - 1]?.totalTestAudit ?? 0
                      : 0;

                  const finalLaunchName =
                    launchType === "final"
                      ? `Final ${ENTITY_LABELS.audit}`
                      : `Test ${ENTITY_LABELS.audit} ${totalTestAudit + 1}`;
                  setActiveTab(launchRecord?.length);
                  discoveryCtx.updateLaunchRecord(
                    launchType === "final"
                      ? { name: finalLaunchName }
                      : { name: finalLaunchName, totalTestAudit: totalTestAudit + 1 }
                  );

                  const isFinal = launchType === "final";
                  discoveryCtx.updateConversationEnabled(isFinal || (launchType === "test" && enableTestConvoContentMap));
                  setTimeout(() => {
                    discoveryCtx.updatedLaunched(true);
                    discoveryCtx.updateLaunchTransaction(true);
                    discoveryCtx.updateLoading(true);
                    setIsAuditRunning(true);
                    setInputValues(values);
                    setTimeout(() => {
                      brandAuditCall(values);
                    }, 500);
                  }, 500);
                }}
                onTypeChanged={(val) => {
                  setInputValues((prevVals) => {
                    return {
                      ...prevVals,
                      type: val,
                    };
                  });
                }}
              />
            </div>
          </div>
          {discoveryCtx.is_launched && (
            <div className={classes.result} id="print-pdf" ref={pdfRef}>
              {(() => {
                const { transactionStatus } = discoveryCtx.state;

                if (transactionStatus === "RETRY") {
                  return (
                    <div className={classes.failMessage}>
                      <div>
                        <span style={{ fontSize: "18px", marginRight: "8px" }}>
                          ⚠️
                        </span>
                        Some requests failed. Click Retry to try again and
                        complete this report.
                      </div>
                      <MUIButton onClick={retryBrandAudit} loading={processRetry}>
                        Retry
                      </MUIButton>
                    </div>
                  );
                }

                if (transactionStatus === "RUNNING" && processRetry) {
                  return (
                    <div className={classes.retryMessage}>
                      <div>
                        <span style={{ fontSize: "18px", marginRight: "8px" }}>
                          ⏳
                        </span>
                        Retry process for missing data is initiated.
                      </div>
                      <MUIButton onClick={retryBrandAudit} loading={processRetry}>
                        Retry
                      </MUIButton>
                    </div>
                  );
                }

                return null;
              })()}
              <div className={classes.launchTabsWrapper}>
                <MUITabs
                  value={activeTab}
                  onChange={handleTabChange}
                  indicatorColor="primary"
                  textColor="primary"
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {discoveryCtx?.state?.launchRecord.map((item, index) => (
                    <Tab key={index} label={item.name} />
                  ))}
                </MUITabs>
              </div>
              {discoveryCtx?.state?.status?.totalCount > 0 && (
                <div className={classes.hideOnPrint}>
                  <ProgressIndicator
                    total={discoveryCtx.state.status.totalCount}
                    completed={discoveryCtx.state.status.completedTaskCount}
                  />
                </div>
              )}
              <PDFHeader />
              <BrandScore
                entity={entity}
                competitors={competitors}
                llms={discoveryCtx.llm}
                market={discoveryCtx?.markets?.[0]}
                categories={discoveryCtx.category}
                dashbaordActiveTab={dashbaordActiveTab}
                setDashbaordActiveTab={setDashbaordActiveTab}
                enableHTMLReport={!!enableHTMLReport}
                transactionId={discoveryCtx.state.transactionId}
              />
              {discoveryCtx.state.showReportCheckbox ? (
                <SelectedComponent
                  generateReport={generateReport}
                  loading={loading}
                  auditJobStatus={auditJobStatus}
                  auditPercent={auditPercent}
                />
              ) : null}
              {enableReport && discoveryType != "category" && !isHTMLReportTabActive && (
                <div className={`${classes.action_btn_group} no-print`}>
                  {/* <MUIButton onClick={exportToPDF}>Export</MUIButton> */}
                  {/* {!discoveryCtx.state.showReportCheckbox && (
                    <MUIButton onClick={selectReportSection} loading={loading}>
                      {"Export Report"}
                    </MUIButton>
                  )} */}
                  {/* <MUIButton onClick={generateReport} loading={loading}>
                    Generate Report
                  </MUIButton>  */}
                  {/* {enableSummaryReport && <MUIButton
                    // onClick={downloadDocxReport}
                    onClick={() => setShowSummaryReportModal("word")}
                    loading={reportLoading}>
                    Generate Summary Report
                  </MUIButton>} */}
                  {/* HTML Report moved to the HTML Report tab in BrandScore */}
                </div>
              )}
              <div className={classes.pagefooter}>
                <PDFFooter />
              </div>
            </div>
          )}
        </div>
      </section>

      {showLunchDialog && (
        <Modal
          handleConfirm={() => setShowLunchDialog(false)}
          open={showLunchDialog}
          title=""
          showActions
          showLaunchDialog
        >
          <div className={classes.contentText}>
            Your {ENTITY_LABELS.brand} {ENTITY_LABELS.audit} has been started.
            We're generating your report based on your selected criteria. Processing time varies depending on the scope and complexity of your request. You can stay on this screen to monitor progress or return later to view the completed report in the History section.
          </div>
        </Modal>
      )}

      <Modal
        title={`Template Setting`}
        width={"1200"}
        children={userMetricSettingCreation()}
        open={showUserMetricSettingModel}
        handleClose={() => {
          dispatch({ type: "ACTION_MODEL", payload: false });
        }}
        confirmBtnText="Add"
      />

      <SummaryReportModal
        open={!!showSummaryReportModal}
        onClose={() => setShowSummaryReportModal(null)}
        onGenerate={(selections) => {
          downloadDocxReport(selections);
          setShowSummaryReportModal(null);
        }}
        brandName={discoveryCtx?.entity}
        loading={reportLoading}
        categories={discoveryCtx.category || []}
        llms={discoveryCtx.llm || []}
        markets={discoveryCtx.markets || []}
        persona={
          discoveryCtx?.persona?.map(item =>
            typeof item === "string" ? item : item?.title
          )?.filter(Boolean) || []
        }
        isComprehensiveReportEnabled={isComprehensiveReportEnabled}
      />
    </>
  );
}
